var React = require('react');

function IconDownload (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M460.6 603.4H359l150.7 141.1c1.5 1.4 3.9 1.4 5.5 0l150.6-141.1H565V105.2c0-2.2-1.8-4-4-4l-95.2.1c-2.2 0-4 1.8-4 4l-1.2 498.1zm-358-118.9c-3.8 0-6.9 3.2-6.9 7.1v428.2c0 3.8 3.1 7.1 6.9 7.1H921c3.8 0 6.9-3.2 6.9-7.1V491.6c0-3.8-3.1-7.1-6.9-7.1H754.6v80.1H850v282.2H173.7V564.7h95.4v-80.1H102.6v-.1z"}));
}

IconDownload.displayName = "IconDownload";

IconDownload.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconDownload;

IconDownload.default = IconDownload;
